import React from 'react';
import { useTranslation } from "react-i18next";

function Footer(){
  const { t } = useTranslation();
  const emailStyle = {
    backgroundPosition: "-18px -198px",
    backgroundImage: "url('./icons/icons.png')"
  };
  const phoneStyle = {
    backgroundPosition: "-54px -198px",
    backgroundImage: "url('./icons/icons.png')"
  };
  const social = [{
    title: "Facebook",
    icon: "FooterFacebook.png",
    link: "https://www.facebook.com/MySchoolDC"
  },{
    title: "Instagram",
    icon: "FooterInstagram.png",
    link: "https://instagram.com/MySchoolDC"
  },{
    title: "Twitter",
    icon: "FooterTwitter.png",
    link: "https://twitter.com/MySchoolDC"
  }];

  return(<div className="bg-[#618c95] py-5 md:py-7 px-5 md:px-7 print:hidden">
    <div className='w-full flex flex-col md:flex-row text-white text-sm'>
      <div className='w-full md:w-2/5 flex flex-wrap flex-row justify-around md:justify-start'>
        <div className='pt-2 pr-3 flex flex-row'>
          <div className='h-7 w-5' style={ emailStyle }></div>
          <p className='pl-2'>{ t('footer.email') }<br/><span className='font-bold'>202-888-6336</span></p>
        </div>
        <div className='pt-2 pr-3 flex flex-row'>
          <div className='h-7 w-5' style={ phoneStyle }></div>
          <p className='pl-2'>{ t('footer.phone') }<br/><a href='mailto:info.myschooldc@dc.gov' className='hover:text-my-emerald font-bold'>info.myschooldc@dc.gov</a></p>
        </div>
      </div>
      <div className='w-full md:w-2/5 pt-3 md:pt-0 md:px-3 text-center md:text-left'>
        { t('footer.disclaimer') }
      </div>
      <div className='w-full md:w-1/5 pt-3 md:pt-0 '>
        <div className='flex flex-row justify-around items-center'>
          {
            social.map((item, i) => {
              return (<a key={ "socialLink_" + item.title } href={ item.link } target="_blank" rel='noreferrer'>
                <img className='w-10' alt={ item.title + " Link" } title={ item.title } src={ "./icons/" + item.icon }></img>
              </a>)
            })
          }
        </div>
      </div>
    </div>
  </div>)
};

Footer.propTypes = {};

Footer.defaultProps = {};

export default Footer;
